import { Box, Card, CardContent, Stack, useTheme } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ChangeItemHeader, CHANGE_TYPE_COLORS } from "./change-item-header"
import { ChangeItemBody } from "./change-item-body"
import { ChangeItemFooter } from "./change-item-footer"

export function ChangeItem({ item: change }) {
    const theme = useTheme()
    const { onDecisionChange, onTextChange, onProposedTaskChange, onCriticalityChange } = useBoundContext()
    const borderColor = theme.palette[resolveBorderPalette(change.decision)] ?? theme.palette.divider
    const typeColor = CHANGE_TYPE_COLORS[change.changeType] ?? "default"

    return (
        <Card
            sx={{
                borderRight: "4px solid",
                borderRightColor: borderColor,
                position: "relative",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    width: 12,
                    bgcolor: `${typeColor}.main`,
                }}
            />
            <CardContent sx={{ pl: 4 }}>
                <Stack spacing={2}>
                    <ChangeItemHeader change={change} onCriticalityChange={handleCriticalityChange} />
                    <ChangeItemBody
                        change={change}
                        onTextChange={onTextChange}
                        onProposedTaskChange={onProposedTaskChange}
                    />
                    <ChangeItemFooter change={change} onDecisionChange={onDecisionChange} />
                </Stack>
            </CardContent>
        </Card>
    )

    function handleCriticalityChange(criticality) {
        onCriticalityChange?.(change.id, criticality)
    }
}

function resolveBorderPalette(decision) {
    switch (decision) {
        case "accept":
            return "success.main"
        case "keep":
            return "text.disabled"
        case "custom":
            return "warning.main"
        default:
            return "divider"
    }
}
